import { FETCH_URGENCIES, INCREMENT_URGENCY, DECREMENT_URGENCY, SET_DEFAULT_VALUE } from 'store/orderform/orderformActionTypes';
import { CLEAR_ORDERFORM } from 'store/actionTypes';

import reducerLogic from 'store/orderform/controls/select/selectReducer';

export const initialState = {
    id: 'urgency',
    name: 'urgency',
    value: 240,
    error: '',
    label: 'Indicate the Deadline',
    tooltip: 'The countdown starts from the moment you receive an email confirming that your payment went through. Kindly consider that it takes around an hour to compose one page of a high-quality text.',
    searchValue: '',
    options: [],
    disabledOptions: [],
    filteredOptions: [],
    searchDisabled: true,
    dropdownOpen: false,
    selectDisabled: false,
    isRequired: false,
    alreadyFetched: false
}

export default function urgencyReducer(state = initialState, action) {

    if (action.type === FETCH_URGENCIES) {
        return {
            ...state,
            options: action.payload,
            alreadyFetched: true
        };

    } else if (action.type === INCREMENT_URGENCY || action.type === DECREMENT_URGENCY) {
        return {
            ...state,
            value: action.payload
        };

    } else if (action.type === SET_DEFAULT_VALUE) {
        return {
            ...state,
            value: action.payload.urgency || state.value
        }

    } else if (action.type === CLEAR_ORDERFORM) {
        return {
            ...state,
            value: action.payload.urgency
        }

    } else {
        return reducerLogic(state, action);
    }
}